import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, DollarSign, Truck } from 'lucide-react';
export function RecentShipments() {
  const shipments = [{
    equipment: 'John Deere 6155M Tractor',
    route: 'Des Moines, IA → Dallas, TX',
    price: '$2,150',
    img: 'https://images.unsplash.com/photo-1592978868971-4191b29a280e?q=80&w=600&auto=format&fit=crop'
  }, {
    equipment: 'Caterpillar 320 Excavator',
    route: 'Atlanta, GA → Orlando, FL',
    price: '$1,850',
    img: 'https://images.unsplash.com/photo-1579847188804-ecba0e2ea330?q=80&w=600&auto=format&fit=crop'
  }, {
    equipment: 'Bobcat T76 Skid Steer',
    route: 'Denver, CO → Phoenix, AZ',
    price: '$1,400',
    img: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?q=80&w=600&auto=format&fit=crop'
  }, {
    equipment: 'Komatsu D61EX Bulldozer',
    route: 'Chicago, IL → Nashville, TN',
    price: '$2,800',
    img: 'https://images.unsplash.com/photo-1504307651254-35680f356f12?q=80&w=600&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-271">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-272">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-273">
          <h2 className="text-3xl md:text-4xl font-black text-brand-navy mb-4" data-id="element-274">
            Recent Equipment Shipments
          </h2>
          <p className="text-lg text-slate-600" data-id="element-275">
            Real examples of our nationwide heavy haul services. We provide
            transparent, competitive transport quotes for machinery of all
            sizes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-276">
          {shipments.map((shipment, index) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} key={index} className="bg-white rounded-xl overflow-hidden shadow-md border border-slate-100 hover:shadow-xl transition-shadow" data-id="element-277">
              <div className="h-40 overflow-hidden" data-id="element-278">
                <img src={shipment.img} alt={`${shipment.equipment} transport`} className="w-full h-full object-cover" data-id="element-279" />
              </div>
              <div className="p-5 space-y-3" data-id="element-280">
                <div className="flex items-center gap-2 text-brand-navy font-bold text-lg" data-id="element-281">
                  <Truck className="w-5 h-5 text-brand-red" data-id="element-282" />
                  {shipment.equipment}
                </div>
                <div className="flex items-start gap-2 text-sm text-slate-600" data-id="element-283">
                  <MapPin className="w-4 h-4 text-slate-400 mt-0.5 shrink-0" data-id="element-284" />
                  <span data-id="element-285">{shipment.route}</span>
                </div>
                <div className="flex items-center gap-2 text-brand-navy font-black text-xl pt-2 border-t border-slate-100" data-id="element-286">
                  <DollarSign className="w-5 h-5 text-green-600" data-id="element-287" />
                  {shipment.price}
                </div>
              </div>
            </motion.div>)}
        </div>
        <p className="text-xs text-slate-400 text-center mt-8" data-id="element-288">
          * Prices shown are real-world examples. Actual heavy equipment
          shipping costs vary based on exact dimensions, weight, route, season,
          and current fuel prices.
        </p>
      </div>
    </section>;
}